<!--
 * @Author: ZhaoDong
 * @Date: 2022-10-25 12:13:06
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-11-18 14:25:19
 * @Description: 选择用户
-->
<template>
  <a-modal width="600px" :visible="visible" title="选择用户" @cancel="handleCancel">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item ref="name" label="用户账号" prop="userList">
        <a-input-group compact>
          <a-button type="default" disabled>{{ projectName }}</a-button>
          <a-input style="width: 220px" v-model="keyword" allowClear placeholder="用户账号" />
          <a-button type="primary" :loading="loading" @click="onSearch" :disabled="!keyword">添加</a-button>
        </a-input-group>
        <div class="selected-staff-container">
          <a-tag color="blue" class="tag-staff" closable @close="() => handleRemove(user)" v-for="user in form.userList" :key="user.user_id">
            {{ user.username }}
          </a-tag>
        </div>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        取 消
      </a-button>
      <a-button key="submit" type="primary" :disabled="form.userList.length === 0" :loading="commitLoading"
                @click="handleSubmit">
        确 定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import api from '@/api/'
function uniqueFun(arr, uni_key) {
  const hash = {}
  return arr.reduce((pre, curr) => {
    !hash[curr[uni_key]] && (hash[curr[uni_key]] = true && pre.push(curr))
    // hash[curr[uni_key]] ? '' : (hash[curr[uni_key]] = true && pre.push(curr))
    return pre
  }, [])
}
export default {
  props: {
    brandId: {
      type: [String, Number],
      default: ''
    },
    projectName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      commitLoading: false,
      visible: false,
      keyword: undefined,
      userOptions: [],
      form: {
        keyword: undefined,
        userList: []
      },
      rules: {
        userList: [{ type: 'array', required: true, message: '请添加用户账号', trigger: ['blur'] }]
      }
    }
  },
  methods: {
    onSearch() {
      this.loading = true
      api
        .QueryUser({ brand_id: Number(this.brandId), username: this.keyword })
        .then(res => {
          if (res.data?.total > 0) {
            const _userTempList = res.data?.list ?? []
            const { userList } = this.form
            this.form.userList = uniqueFun([...userList, ..._userTempList], 'user_id')
          } else {
            this.$message.warning('用户账号不存在！')
          }
        })
        .finally(() => {
          this.keyword = undefined
          this.loading = false
        })
    },
    handleRemove(user) {
      this.form.userList = this.form.userList.filter(u => u.user_id !== user.user_id)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.$emit('ok', this.form.userList)
          this.close()
        }
      })
    },
    open(userList) {
      this.visible = true
      if (Array.isArray(userList)) {
        this.form.userList = userList
      }
    },
    close() {
      this.visible = false
      this.$refs.ruleForm.resetFields()
      this.$refs.ruleForm.clearValidate()
    },
    handleCancel() {
      this.close()
      this.previewVisible = false
    }
  },
  components: {}
}
</script>

<style scoped lang="less">
.selected-staff-container {
  max-height: 300px;
  overflow: auto;

  .tag-staff {
    margin-right: 8px !important;
  }
}
</style>
